// @flow
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { displayNumber } from 'common/components/Number';
import IncreaseDecreasePercent, { calculateIncreaseDecreasePercent } from 'statsradio/components/IncreaseDecreasePercent';
import type { ComparedMetric } from 'statsradio/modules/dashboard/domain/DashboardData';
import { Metric } from 'statsradio/themes/v3/Stylesheet';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 170px;
`;

const MetricTitle = styled.div`
  color: ${props => props.theme.V3.colors.text.title};
  font-size: 14px;
  text-align: center;
  padding-bottom: ${props => props.theme.V3.metrics.margin.tiny}px;
`;

export const SmallMetric = styled(Metric)`
  font-size: ${props => props.theme.V3.fonts.smallMetrics.size}px;
`;

interface Props {
  title: string;
  value: number | ComparedMetric;

  theme: any;
}

export function ReachMetric(props: Props) {
  const { title, value, theme } = props;
  const converter = (n => n);
  const current = converter(typeof value === 'number' ? value : value.current);
  const compared = converter(typeof value === 'number' ? undefined : value.compared);

  let percentToDisplay;
  if (compared) {
    percentToDisplay = calculateIncreaseDecreasePercent(value);
  }

  return (
    <Container>
      <MetricTitle>
        {title}
      </MetricTitle>
      {!percentToDisplay &&
      <Metric color={theme.V3.colors.reach}>
        {displayNumber(current)}
      </Metric>
      }
      {percentToDisplay &&
      <React.Fragment>
        <IncreaseDecreasePercent
          percent={percentToDisplay}
          iconSize={{ width: theme.V3.metrics.icon.size, height: theme.V3.metrics.icon.size }}
          textStyle={{ fontSize: 30 }}
        />
        <SmallMetric color={theme.V3.colors.reach}>
          {displayNumber(current)}
        </SmallMetric>
      </React.Fragment>
      }
    </Container>
  );
}

export default withTheme(ReachMetric);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/reachMetricsOverview/ReachMetric.js